import React, {Component} from 'react';
import NewsletterSignupForm from './NewsletterSignupForm'

export default class ModalNewsLetter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            emailSend: false,
            invalidEmailForm: false
        };
    };

    signupSuccess = () => {
        this.setState({emailSend: true})
    };

    onInvalidEmailForm = () => {
        this.setState({invalidEmailForm: true});
    };

    onValidEmailForm = () => {
        this.setState({invalidEmailForm: false});
    };

    closeModal = () => {
        this.props.closeModal()
    };

  componentWillMount = () => {
    document.body.classList.add("noScroll");
    document.documentElement.classList.add('noScroll');

    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  componentWillUnmount = () => {
    document.body.classList.remove('noScroll');
    document.documentElement.classList.remove('noScroll');

      // scroll to result
      $('html, body').animate({scrollTop: $('.result-information').offset().top}, 'slow');
  };

    render() {
        return (
            <div className="share-popup">
                <div className="inner">
                    <span className="close" onClick={this.closeModal}></span>
                    <h2>Påmelding til nyhetsbrev</h2>
                    <p>Bli oppdatert på våre siste nyheter om anskaffelser og få informasjon om våre aktiviteter og invitasjoner til faglige arrangementer. Vi bruker kun dine opplysninger til utsendelse av nyhetsbrevet, og sletter de dersom du melder deg av eller vi slutter med å sende ut nyheter. Les mer om hvordan vi behandler dine opplysninger her.</p>
                    {!this.state.emailSend &&
                    <div id="share-input">
                        <NewsletterSignupForm
                            onSignUpSuccess={this.signupSuccess}
                            onValidForm={this.onValidEmailForm}
                            onInvalidForm={this.onInvalidEmailForm}
                        />
                        {this.state.invalidEmailForm &&
                        <div className="error" style={{'marginTop': '10px'}}>Det oppsto en feil i e-posten din.</div>
                        }
                    </div>
                    }

                    {this.state.emailSend &&
                    <div>
                        <p><strong>Takk for at du registrerte deg.</strong></p>
                    </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalNewsLetter.js